import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineNotice } from '@wit-support/ui';
import { ShieldAlert } from 'lucide-react';
import { objectLabel } from '../naming.js';
import { AdsTime } from './ads-time.js';
const MEDIA_RU = {
    'media.image': 'Картинка',
    'media.video': 'Видео',
};
/**
 * Что отклонила Meta: «Креатив · Группа 1 / Объявление 2», «Кампания»,
 * «Видео». localRef файла — внутренний хеш, на экран не выводится.
 */
export function remoteValidationObjectRu(item) {
    const media = MEDIA_RU[item.kind];
    if (media)
        return media;
    const label = objectLabel(item.kind, item.localRef);
    return item.kind === 'creative' && !label.startsWith('Креатив') ? `Креатив · ${label}` : label;
}
/** Код ошибки Meta: «код 100 / 2446603». */
export function remoteValidationCodeRu(item) {
    return item.subcode != null ? `код ${item.code} / ${item.subcode}` : `код ${item.code}`;
}
/** Текст ошибки одной проверки: заголовок — пояснение Meta; иначе технический. */
function itemText(item) {
    const parts = [item.title, item.userMsg].filter((x) => x != null && x !== '');
    return parts.length > 0 ? parts.join(' — ') : (item.message ?? '');
}
/**
 * Meta отклонила запуск на предпроверке (validate_only): ничего не создано,
 * шагов нет — причина «Ошибки» здесь. Нет поля (старый auto-ads или
 * предпроверка прошла) — блока нет.
 */
export function RemoteValidationNotice({ failure, }) {
    if (failure == null)
        return null;
    return (_jsx(InlineNotice, { variant: "danger", bordered: true, icon: ShieldAlert, as: "div", "data-testid": "remote-validation-failure", children: _jsxs("div", { className: "flex flex-col gap-1.5", children: [_jsx("span", { className: "font-medium [overflow-wrap:anywhere]", children: failure.text }), _jsxs("span", { className: "text-xs", children: ["\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u043E: Meta \u043E\u0442\u043A\u043B\u043E\u043D\u0438\u043B\u0430 \u0437\u0430\u043F\u0443\u0441\u043A \u0435\u0449\u0451 \u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 \u043F\u0435\u0440\u0435\u0434 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043C", failure.at != null ? (_jsxs(_Fragment, { children: [' ', "(", _jsx(AdsTime, { iso: failure.at }), ")"] })) : null, ". \u0418\u0441\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0438 \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0441\u043D\u043E\u0432\u0430."] }), failure.items.length > 0 ? (_jsx("ul", { className: "flex flex-col gap-0.5 text-xs", "data-testid": "remote-validation-items", children: failure.items.map((it, i) => (_jsxs("li", { className: "[overflow-wrap:anywhere]", title: [
                            it.message ? `Meta: ${it.message}` : null,
                            it.fbtraceId ? `fbtrace_id: ${it.fbtraceId}` : null,
                        ]
                            .filter(Boolean)
                            .join('\n'), children: [_jsx("span", { className: "font-medium", children: remoteValidationObjectRu(it) }), ' · ', _jsx("span", { className: "text-[var(--color-text-secondary)]", children: remoteValidationCodeRu(it) }), itemText(it) !== '' ? _jsxs(_Fragment, { children: [" \u2014 ", itemText(it)] }) : null] }, `${it.kind}:${it.localRef}:${i}`))) })) : null] }) }));
}
/**
 * Причина «Ошибки» запуска одной строкой для таблицы пачки: `lastError`
 * (теперь и с предпроверки, код `remote-validation`); старый ответ без него —
 * текст предпроверки. `title` — что именно отклонено и с каким кодом.
 */
export function remoteValidationTitle(failure) {
    if (failure == null || failure.items.length === 0)
        return null;
    return failure.items
        .map((it) => `${remoteValidationObjectRu(it)} · ${remoteValidationCodeRu(it)}`)
        .join('\n');
}
//# sourceMappingURL=remote-validation.js.map